/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { UsersListContainer } from './container';
// import { useHistory } from "react-router-dom";

export const UsersListPage = ({ navigation }: { navigation: any }) => {
  // let history = useHistory();

  return (
    <UsersListContainer
    // onViewClick={(id: string) => history.push(`/users/${id}`)}
    />
  );
};
